import { render, staticRenderFns } from "./UsersubTable.vue?vue&type=template&id=b58f0932&scoped=true&"
import script from "./UsersubTable.vue?vue&type=script&lang=js&"
export * from "./UsersubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58f0932",
  null
  
)

export default component.exports